import { makeAutoObservable } from "mobx"

export default class ReportSection {

  constructor(reportSection={}) {
    this.id = reportSection.id
    this.campaign_report_id = reportSection.campaign_report_id
    this.title = reportSection.title || ''
    this.free_text = reportSection.free_text || ''
    this.visible = !!reportSection.visible
    this.default_section = !!reportSection.default_section
    this.section = reportSection.section
    this.created_at = reportSection.created_at
    this.updated_at = reportSection.updated_at
    this._destroy = false

    makeAutoObservable(this)
  }
}
